<div
  class="loading-icon-component"
  [ngClass]="[_theme, _size]"
  [ngStyle]="styleExp"
>
  <svg
    class="loading-icon-svg"
    preserveAspectRatio="xMidYMid meet"
    focusable="false"
    viewBox="0 0 100 100"
    role="img"
    [attr.aria-label]="svgAriaLabel"
  >
    <circle cx="50%" cy="50%" r="45"></circle>
  </svg>
</div>
